import { useState } from "react";

import { Portal } from "@blueprintjs/core";

import { Box } from "@/components/layout/flexbox";
import { BackDrop } from "@/components/pieces/BackDrop";
import { ScrollableModal } from "@/components/pieces/ScrollableModal";
import { PORTAL_Z_INDEX } from "@/css/constants";

export function CostExplainer() {
  const [showingExplainer, setShowingExplainer] = useState(false);
  return (
    <Box
      py={2}
      px={3}
      fontWeight={500}
      style={{
        background: "rgb(245, 245, 251)",
        borderLeft: "3px solid rgb(221, 217, 238)",
        borderRadius: "3px 6px 6px 3px",
      }}
    >
      <a
        href="#"
        onClick={(e) => {
          e.preventDefault();
          setShowingExplainer(true);
        }}
      >
        Why do I have to pay for the intro call?
      </a>
      <Portal>
        <BackDrop
          visible={showingExplainer}
          zIndex={PORTAL_Z_INDEX}
          opacity={0.6}
        />
        <ScrollableModal
          visible={showingExplainer}
          onClose={() => setShowingExplainer(false)}
          verticallyCenter={true}
          canOutsideClickClose={true}
        >
          <Box
            backgroundColor="#FFF"
            className="round-corners"
            width={650}
            maxWidth="100%"
            p={24}
          >
            <div style={{ padding: "56.25% 0 0 0", position: "relative" }}>
              <iframe
                src={`https://player.vimeo.com/video/644436278?h=9da8a199e4&amp;badge=0&amp;&amp;player_id=0&amp;app_id=58479&amp;autoplay=${
                  showingExplainer ? "1" : "0"
                }&amp;autopause=${!showingExplainer ? "1" : "0"}`}
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  border: 0,
                }}
                title="Why Do I Have To Pay"
              />
            </div>
            <script src="https://player.vimeo.com/api/player.js"></script>
          </Box>
        </ScrollableModal>
      </Portal>
    </Box>
  );
}
